module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-25-Active-Rumble-7898fd4f6109526a0c67cf188d979e51.png";